import gql from 'graphql-tag';
import { fragments } from '@dengl/embeds/index.js';

export default gql`
	fragment UserContentDetails on UserContent {
		id
		content {
			markdown(parserType: "FORUM")
			rawMarkdown: markdown(raw: true)
			embeds {
				...EmbedDataFragment
			}
		}
		user {
			id
			slug
			username
			isClubmember
			avatar
			role
			roleLabel
		}
		created_at
		votes {
			total
			voted
		}
		isSpam
		isReported

		meta {
			adminPath
		}
		... on Topic {
			moderation {
				user {
					id
					username
					slug
				}
				commentPublic
				created_at
			}
			user {
				signature
			}
			edited {
				editedBy {
					username
					role
				}
				editedAt
			}
			parserType: markdownParserType
		}
		... on Reply {
			moderation {
				user {
					id
					username
					slug
				}
				commentPublic
				created_at
			}
			user {
				signature
			}
			edited {
				editedBy {
					username
					role
				}
				editedAt
			}
			parserType: markdownParserType
			parent {
				id
				type: __typename
			}
		}
		... on Review {
			travelCompanions
			activity
			experience
			rating
		}
	}
	${fragments}
`;
